import React from 'react';
import './Workshops.css';
import Fein from '../../img/workshops/Fein.jpg';
import Snakedev from '../../img/workshops/Snakedev.svg';

export default class Workshops extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      workshops: [
        {
          date: '2022, December 1',
          photo: Fein,
          name: 'Pete Fein',
          position: 'Consultant',
          logo: Snakedev,
          title: 'Data Engineering from Notebook to Production',
          bookHref: 'https://events.geekle.us/workshops/PeteFein#ticket',
          price: '$199',
          learnMore: 'https://events.geekle.us/workshops/PeteFein/',
        },
      ]
    }
  }

  renderWorkshops(item, i) {
    return (
      <div className="workshops_item" key={`workshops-${i}`}>
        <div className="workshops_item--header">
          <div className='workshops_item-title_wrap'>
            <p className='workshops_item-title'>Workshop #{i + 1}</p>
            <p className='workshops_item-date'>{item.date}</p>
          </div>
          <div className='workshops_item-info'>
            <img className='workshops_item-info_img' src={item.photo} alt="" />
            <div className='workshops_item-info_content'>
              <p className="workshops_item_name">{item.name}</p>
              <p className="workshops_item_position">{item.position}</p>
              <img className='workshops_item_logo' src={item.logo} alt="" />
            </div>
          </div>
        </div>
        <div className='workshops_item-content'>
          <p className='workshops_title'>"{item.title}" <a className='button workshops_button--white_border' target='_blank' rel="noreferrer" href={item.learnMore}>Learn more</a></p>
          <div className='workshops_buttons'>

            <a className='button' target='_blank' rel="noreferrer" href={item.bookHref}>Book for {item.price}</a>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="workshops_wrap" id='workshops'>
        <div className='container workshops'>
          <h2>Workshops</h2>
          <div className="workshops_block">
            {this.state.workshops.map((item, i) => this.renderWorkshops(item, i))}
          </div>
        </div>
      </div>
    )
  }
}